import useQueryGetGeneralSetting from '@/modules/client-setting/api/hooks/useQueryGetGeneralSetting'

interface UsernameCellProps {
	username: string | null | undefined
}

export function UsernameCell({ username }: UsernameCellProps) {
	const { data: generalSetting } = useQueryGetGeneralSetting()
	const isMaskEnabled = generalSetting?.enableMaskPhone ?? true

	if (!isMaskEnabled) {
		return <span>-</span>
	}

	return <span>{username || '-'}</span>
}
